"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = replaceInvalidCharacters;
var _isString = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function replaceInvalidCharacters() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var additionalCharacterMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{}];
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var characterReplacementMap = [{
    pattern: /“/g,
    replacement: '"'
  }, {
    pattern: /‘/g,
    replacement: "'"
  }].concat(additionalCharacterMap);
  return characterReplacementMap.reduce(function (acc, mapItem) {
    return acc.replace(mapItem.pattern, mapItem.replacement);
  }, value);
}